import React, { useEffect, useState } from 'react'
import AddJobSideBar from '../../components/AddJobSideBar'
import TopNavigation from '../../layouts/top-navigation/TopNavigation'
import AdditionalDetails from './AdditionalDetails'
import AddJob from './AddJob'
import EducationDetails from './EducationDetails'
import ExperienceLevel from './ExperienceLevel'
import JobDescription from './JobDescription'
import JobForwardandBackward from './JobForwardandBackward'
import ProfileInfo from './ProfileInfo'
import RecruitmentSettings from './RecruitmentSettings'
import Summary from './Summary'
import JobDescriptionHeader from './JobDescriptionHeader'
import { useAppDispatch } from '../../useStore'
import { input } from '../../features/Auth/authSlice'



const JobProfileContainer = () => {
	const dispatch = useAppDispatch();


	// const { data } = useAppSelector((state: { auth: any; }) => state.auth)
	// State to store count value 

	const [active, setActive] = useState<number>(1)
	const [summary, setSummary] = useState<any>(true)
	useEffect(() => {
		setActive(active)
	}, [active])

	useEffect(() => {
		if (active === 8) {
			setSummary(false)
		} else {
			setSummary(true)
		}
	}, [active])




	const [inputs, setInputs] = useState({
		employmentType: "",
		experienceLevel: "",
		education: "",
		jobFunction: "",
		jobRole: "",
		jobProfile: "",
		team: "",
		remote: false,
		jobDescription: "",
		qualifications: "",
		mustHaveSkills: [],
		goodHaveSkills: [],
		summary: "",
		profileInfo: true,
		educationDetails: false,
		workExperience: false,
		additionalDetails: false,
		userId: "",
		email: true,
		location: true,
		currentSalary: false,
		noticePeriod: false,
		totalWorkExperience: false,
		resume: true,
		hiringManager: "",
		recruiterTagged: "",
		numberOfOpenings: "",
		openingDate: "",
		expiryDate: "",
		makeJobPrivate: false,
		firstname: true,
		lastname: true,
		linkedinUrl: false,
		Phone: true,
		expectedSalary: false,
		relevantWorkExperience: false,
		reasonForJobChange: false,
		jobLocation: "",
		workplaceType: "",
	})



	useEffect(() => {
		localStorage.setItem("inputs", JSON.stringify(inputs));
	}, [inputs])


	const Infodata = async () => {
		dispatch(input());
	};

	useEffect(() => {
		Infodata();
	}, [Infodata, inputs]);



	return (
		<div id="screen-wrapper">
			<TopNavigation />
			<AddJobSideBar active={active} />
			<main>
				{summary ? <div className='AddJob_main_container'>
					<div className='AddJob_container_main'>
						{active === 1 && <JobDescriptionHeader title={"Set up your recruitments options."} />}
						{active === 2 && <JobDescriptionHeader title={"Describe your job."} />}
						{active === 3 && <JobDescriptionHeader title={"Set up your recruitments options."} />}
						{active === 4 && <JobDescriptionHeader title={"Set up your recruitments options."} />}
						{active === 5 && <JobDescriptionHeader title={"Define fields for applicants."} />}
						{active === 6 && <JobDescriptionHeader title={"Define fields for applicants."} />}
						{active === 7 && <JobDescriptionHeader title={"Define fields for applicants."} />}
						{active === 8 && <JobDescriptionHeader title={"Summary"} />}
						<div className='active-container'>
							{active === 1 && <AddJob inputs={inputs} setInputs={setInputs} />}
							{active === 2 && <JobDescription inputs={inputs} setInputs={setInputs} />}
							{active === 3 && <RecruitmentSettings inputs={inputs} setInputs={setInputs} />}
							{/* @ts-ignore */}
							{active === 4 && <ProfileInfo autocomplete={false} setInputs={setInputs} inputs={inputs} />}
							{active === 5 && <EducationDetails setInputs={setInputs} inputs={inputs} />}
							{active === 6 && <ExperienceLevel setInputs={setInputs} inputs={inputs} />}
							{active === 7 && <AdditionalDetails setInputs={setInputs} inputs={inputs} />}
						</div>
						<div className='AddJob_main_container_button'>
							<JobForwardandBackward setActive={setActive} active={active} />
						</div>
					</div>
				</div> :
					<div>
						<div className='Summary-contaner-header'>
							<div>
								<JobDescriptionHeader title={"Summary"} />
							</div>
							<div className='JobForwardandBackward-container'>
								<JobForwardandBackward setActive={setActive} active={active} />
							</div>
						</div>
						<Summary />
					</div>}

			</main>
		</div>
	)
}

export default JobProfileContainer
